import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import * as usuarioAccions from './usuario.actions';
import * as globalAccions from './../global/global.actions';
import { mergeMap, map, catchError, find, tap, filter, exhaustMap, switchMap, delay, take, concatMap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from '../../modulos/auth/services/auth.service';
import { AlertService } from '../../services/alert.service';
import { HttpResponse } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { AplicacionPermisoService } from 'src/app/modulos/admin/services/aplicacion-permiso.service';
import { AplicacionesService } from 'src/app/modulos/admin/services/aplicaciones.service';
import { elementoNivelPermiso } from '../global/global.actions';
import { DatePipe } from '@angular/common';
import { ElementoNivelPermisoService } from 'src/app/modulos/admin/services/elemento.nivel.permiso.service';
import { IpPublicService } from 'src/app/services/ip-public.service';
import { ConstantsService } from 'src/app/services/constants.service';
import { ConstantsCatalogosIdService } from 'src/app/services/constants-catalogos-id.service';


@Injectable({
    providedIn: 'root'
})
export class UsuarioEffects {
    date = new Date();
    pipe = new DatePipe('en-US');
    private fechaHoy = this.pipe.transform(this.date, 'yyyy-MM-dd');
    private ipAddress!: string;

    constructor(
        private actions$: Actions,
        private authService: AuthService,
        private aplicacionPermisoService: AplicacionPermisoService,
        private aplicacionService:AplicacionesService,  
        private router: Router,
        private alert: AlertService,
        private store: Store<AppState>,
        private elementoNivelPermisoService:ElementoNivelPermisoService,
        private ip: IpPublicService,
        
    ) {}

    ngOnInit(): void {
        this.getIpPublic();
      }

      getIpPublic(){
        this.ip.getIPAddress().subscribe((res:any)=>{
          this.ipAddress=res.ip;
            });
    
    
      }

    login$ = createEffect(() => this.actions$.pipe(
        ofType(usuarioAccions.login),
        
        mergeMap((resp) =>
            this.authService.authRedux({nombreUsuario: resp.nombreUsuario, claveUsuario: resp.claveUsuario}).pipe(                    
            //this.aplicacionServicioService.list().pipe(                
                concatMap((response) => [
                    usuarioAccions.loginSuccess({ ...response,      
                    }),
                    globalAccions.ambienteSeleccionado({ambiente: response.user.roles[0].ambiente, rol: response.user.roles[0]}),
                    globalAccions.elementoNivelPermiso()            
                ]), 
                                   
                catchError((err)=> 
                {
                    //this.alert.alert("Atención!", err+": No se ha podido validar sus credenciales.", "warning");
                    return of(usuarioAccions.loginError({ payload: err }))
                }),               
            ))
    ));

    logOut$ = createEffect(() => this.actions$.pipe(
        ofType(usuarioAccions.logout),
        map((response) =>
            usuarioAccions.logoutSuccess()
        ),catchError((err)=>{                
            return of(usuarioAccions.logoutError({ payload: err }))
        })
    ));

    $LoginRedirectTo = createEffect(() => this.actions$.pipe(
        
        ofType(usuarioAccions.loginSuccess),                
        tap(x=>{
            this.cerrarCandados();          
            this.router.navigateByUrl('admin/dashboard')}             
        )
    ),{ dispatch: false });    


    $LogOutRedirectTo = createEffect(() => this.actions$.pipe(
        ofType(usuarioAccions.logoutSuccess),                
        tap(x=>{

            // this.alert.alert("POLICÍA NACIONAL DEL ECUADOR", "Gracias por utilizar el sistema SPR.", "info");                   
            this.router.navigateByUrl('login/auth');
        }),  
    ),{ dispatch: false });

    
    /**
     * !EFECTO EN CONSTRUCCION - SE AGREGA LA LISTA DE APLICACIONES AL STPRE DEL USUARIO ACTUAL
     * dispatchable from roles-aplicaciones.component.ts
     */
    addAplicacion$ = createEffect(() => this.actions$.pipe(
        ofType(usuarioAccions.addAplicacion),
        mergeMap((resp)=>
            // this.aplicacionService.list(`/${resp.idSprAplicacion}`).pipe(
            //     tap(x=>{            

            //     })
            // ),
            this.aplicacionPermisoService.list(`?idSprAplicacion=${resp.idSprAplicacion}&idSprRol=${resp.idSprRol}`).pipe(                
                map((response)=>({
                    idSprPermiso: response.idSprRol
                })),                
                tap((x)=>{
   
                }),
                catchError((err)=> {                                    
                    return of(err)
                }),                
            )            
        ),
        
    ));


    //Procesar/desactivar candado pasados de la fecha actual
    cerrarCandados(){
        this.elementoNivelPermisoService.list(`?estado=1`).pipe(
          tap(x=>{})
        ).subscribe({
        next:(resp)=>{
        
          for (let index = 0; index < resp.length; index++) {
             console.log('[INFO] comparar: ', resp[index].fechaFin, "<", this.fechaHoy);
              if(resp[index].fechaFin < this.fechaHoy){
                 this.elementoNivelPermisoService.update(
                   {
                     idSprElementoNivelPermiso:resp[index].idSprElementoNivelPermiso,
                     estado:2,
                     usuario:ConstantsCatalogosIdService.USUARIO_ADMIN,
                     ip:this.ipAddress,
                     comentario: resp[index].comentario + ", Cerrado por el sistema SPR el:  " +this.fechaHoy             
                    }).subscribe({
                      next:(resp)=>{                             
                      },
                      error:(error)=>{
                        console.log('[ERROR] ',error );
                      }
                    })           
                  
              }
            const element = resp[index];    
          }
        },
        error:(error)=>{
          console.log('[ERROR] ', error );
        }
        })
        }
   
          

}
